<section class="section1">
  <app-information-slider></app-information-slider>
</section>

<section style="background-color: #D1CDFF; padding: 2rem;">
  <div style="text-align: center;">
    <h1 style="font-size: 3rem; font-weight: bold; color: #1100CF; margin-top: 1.5rem;">À propos de nous</h1>
  </div>

  <div>
    <p style="font-size: 1.5rem; padding: 2rem; line-height: 1.5;">
      Notre plateforme de traitement des réclamations bancaires a été créée pour fournir une solution efficace et accessible à tous les clients rencontrant des problèmes avec leurs services bancaires. Nous nous engageons à offrir un service transparent et à travailler en étroite collaboration avec les banques pour garantir que chaque réclamation soit traitée de manière juste et rapide.
    </p>
  </div>

  <div style="text-align: center; margin-top: 1.5rem;">
    <button style="font-size: 1.2rem; background-color: #411405; color: #FFFB00; border-radius: 1.5rem; padding: 0.5rem 2rem; font-weight: 700;">En savoir plus</button>
  </div>
</section>

<section style="background-image: url('../../assets/section3Background.png'); background-size: 90%; background-repeat: no-repeat; padding: 2rem;">
  <div style="text-align: center;">
    <h1 style="font-size: 3rem; font-weight: bold; color: #1100CF; margin-top: 1.5rem; line-height: 1.5;">Questions Fréquemment Posées</h1>
  </div>

  <div>
    <p style="font-size: 1.25rem; padding: 1.5rem; line-height: 1.5;">
      <b>Q: Combien de temps faut-il pour traiter une réclamation ?</b><br>
      R: Le délai de traitement d'une réclamation varie en fonction de sa complexité. En général, cela prend entre 5 et 15 jours ouvrables.<br><br>
      <b>Q: Comment puis-je suivre l'évolution de ma réclamation ?</b><br>
      R: Vous pouvez suivre l'évolution de votre réclamation directement depuis votre tableau de bord sur notre plateforme.<br><br>
      <b>Q: Qui peut utiliser cette plateforme ?</b><br>
      R: Tout client ayant un compte bancaire peut utiliser notre plateforme pour soumettre une réclamation.
    </p>
  </div>

  <div style="text-align: center; color: #1B00E7; font-size: 1.5rem; font-weight: bold; text-decoration: underline;">
    <a style="cursor: pointer;">Voir toutes les FAQ</a>
  </div>
</section>

<section style="margin: 2rem 0; background-image: url('../../assets/section4Background.png'); background-size: cover; padding: 2rem;">
  <div style="display: flex; flex-wrap: wrap;">
    <div style="width: 100%; max-width: 30%; font-size: 2.5rem; line-height: 1.5; color: #0B0084; font-weight: bold; padding-top: 3rem; padding-left: 1.5rem;">
      Ressources et Support
    </div>
    <div style="flex: 1; padding: 2rem; font-size: 1.5rem; line-height: 1.5;">
      <p>Accédez à une bibliothèque de ressources pour mieux comprendre vos droits bancaires et obtenir des conseils sur la gestion des réclamations.</p>
      <button style="font-size: 1.2rem; background-color: #00D30E; color: white; padding: 1rem; width: 100%; max-width: 12rem; border-radius: 0.5rem;">Accéder aux ressources</button>
    </div>
  </div>
</section>

<section style="background-image: url('../../assets/section5Background.png'); background-size: cover; padding: 2rem;">
  <div style="width: 100%; max-width: 30%; color: #0B0084; font-size: 2.5rem; font-weight: bold; padding-top: 1.5rem; padding-left: 1.5rem; line-height: 1.5;">
    Témoignages Clients
  </div>
  <div style="display: flex; flex-wrap: wrap; padding: 1.5rem;">
    <p style="flex: 1; font-size: 1.5rem; line-height: 1.5; padding: 1.5rem;">Découvrez les expériences de nos clients et comment notre plateforme les a aidés à résoudre leurs litiges bancaires.</p>
    <button style="font-size: 1.2rem; background-color: #00D30E; color: white; padding: 1rem; max-width: 50%; border-radius: 0.5rem;">Voir les témoignages</button>
  </div>
</section>

<section style="background-color: #060049; display: flex; flex-direction: column; justify-content: center; padding: 2rem;">
  <div style="font-size: 2.5rem; color: #DFE300; font-weight: bold; text-align: center; margin-top: 1.5rem;">Contactez-Nous</div>
  <div style="padding: 1.5rem; width: 80%; margin: auto;">
    <p style="font-size: 1.5rem; color: white; line-height: 1.5;">
      Pour toute question ou assistance supplémentaire, n'hésitez pas à nous contacter via notre formulaire de contact ou par téléphone.
    </p>
    <div style="text-align: center;">
      <button style="background-color: #E5FF45; padding: 1rem; max-width: 15rem; font-size: 1.2rem; border-radius: 0.5rem; font-weight: bold;">Formulaire de contact</button>
    </div>
  </div>
</section>
